import { useState, FC, useEffect } from 'react';
import classnames from 'classnames';
import { coreService } from 'network-utils';
import { Button, Tabs, Icon, FullPageLoader } from 'learning-panel-components';
import { translate } from 'translations';
import UserLeaderboardContainer from './challengeUserLeaderboardContainer';
import styles from './challengeLeaderboard.module.scss';
import TeamLeaderboardContainer from './challengeTeamLeaderboardContainer';

const ChallengeLeaderboard: FC<ChallengeLeaderboardProps> = (props: ChallengeLeaderboardProps) => {
    const { onClose, currentChallenge } = props;
    const [tab, setTab] = useState<number>(TabsType.users);
    const [isTransitioning, setIsTransitioning] = useState<boolean>(true);

    useEffect(() => {
        isTransitioning &&
            window.setTimeout(() => {
                setIsTransitioning(false);
            }, 400);
    }, []);

    return isTransitioning ? (
        <FullPageLoader />
    ) : (
        <div className={styles.leaderboard}>
            <div className={styles.wrapper}>
                <div className={styles.top}>
                    <img
                        alt="leaderboardChallenge"
                        src={`${process.env.PUBLIC_URL}/images/challengeLeaderboardBackground.svg`}
                        className={styles.img}
                    />
                    <div className={styles.score}>
                        <Icon name="devCoin" className={styles.icon} />
                        <div className={styles['score-text']}>{currentChallenge?.maxScore.toLocaleString()}</div>
                    </div>
                    <div className={styles.title}>
                        <div className={styles['top-title']}>
                            <Icon name="challengeIconLearningPanel" className={styles['challenge-icon']} />
                            <div className={styles.text}>{translate('CHALLENGE')}</div>
                            <div className={styles.level}>{`(${currentChallenge?.level})`}</div>
                        </div>
                        <div className={styles.name}>{currentChallenge?.displayName}</div>
                    </div>
                    <div className={styles.language}>{currentChallenge?.language}</div>
                </div>
                <div className={styles.tabs}>
                    <Tabs
                        title={translate('LeaderBoard')}
                        currentTabId={tab}
                        onTabClick={(id: number) => {
                            setTab(id);
                        }}
                        tabs={[
                            { id: TabsType.users, title: translate('Users') },
                            { id: TabsType.teams, title: translate('Teams') }
                        ]}
                    />
                </div>
                <div className={classnames(styles.content, { [styles['teams-content']]: tab === TabsType.teams })}>
                    {tab === TabsType.users && (
                        <UserLeaderboardContainer key={TabsType.users} challengeUuid={currentChallenge?.uuid} />
                    )}
                    {tab === TabsType.teams && (
                        <TeamLeaderboardContainer key={TabsType.teams} challengeUuid={currentChallenge?.uuid} />
                    )}
                </div>
            </div>
            <div className={styles['bottom-section']}>
                <div className={styles['button-wrapper']}>
                    <Button text={translate('close')} type="gradient" onClick={() => onClose()} />
                </div>
            </div>
        </div>
    );
};

enum TabsType {
    users,
    teams
}

interface ChallengeLeaderboardProps {
    onClose: Function;
    currentChallenge?: coreService.ChallengeData;
}

export default ChallengeLeaderboard;
